import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {updateCollection, updateNavigationParam, updatePartnerUser} from "../../redux/systemSlice";
import {connect} from "react-redux";
import Utils, {withRouterHOC} from "../../utils";
import {withCookies} from 'react-cookie';
import Storage from '../../utils/storage';
import {Link} from "react-router-dom";

import './login.css';
import API from "../../app/api";
import {ReactComponent as LogoIcon} from "../../images/logo.svg";
import TextField from "../../app/components/ui/textField/textField";
import {ReactComponent as GoToNaPartnerIcon} from "../../images/goToNaPartner.svg";
import Button from "../../app/components/ui/button/button";

class RegisterPartners extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: null,
            phone: null,
            password: null,
            firstName: null,
            lastName: null,

            activeTab: 'portal',
            tabs: {
                portal: 'на портал',
                partners: 'партнерам'
            },

            errorText: null,

            step: 1,
        }

        this.register = () => {
            this.setState({errorText: null})
            API.registerPartners(this.state.email, this.state.password, this.state.firstName, this.state.lastName, this.state.phone)
                .then(data => {
                    if (data.status) {
                        const jwtToken = data.token;
                        this.props.cookies.set('token', jwtToken, {path: '/'})
                        Storage.set('token', jwtToken)

                        API.profilePartner()
                            .then(data => {
                                Storage.set('user', data)
                                data.authorize = true
                                this.props.updatePartnerUser(data)
                                window.location.href = '/register/partners/shop/create/'
                            })
                            .catch(e => {
                                this.props.updatePartnerUser({authorize: false})
                            })

                    } else {
                        this.setState({errorText: data.message})
                        this.props.updateUser({authorize: false})
                    }
                })
        }
    }

    componentDidMount() {
        this.props.updateNavigationParam({
            page: 'register',
        })

        Utils.setPageTitle(`Регистрация | ПабХаб`)
    }

    render() {
        return (
            <div className='auth-container'>
                <div className='logo'>
                    <LogoIcon/>
                    <div className='for-business'>
                        для бизнеса
                    </div>
                </div>
                <div className='auth'>
                    <div className='auth-form'>
                        {/*<Button customClass='switch-button' type='secondary' size='large' endIcon={<GoToNaPartnerIcon/>}*/}
                        {/*        href='/register/portal/'*/}
                        {/*        fullWidth>*/}
                        {/*    Регистрация на портале*/}
                        {/*</Button>*/}

                        <div className='card'>
                            <div className='header'>
                                <div className='label'>Регистрация для бизнеса</div>
                            </div>
                            <div className='inputs'>
                                <div className='input'>
                                    <TextField label='Имя' type='text' name='first_name' fullWidth
                                               autoComplete="new-password" value={this.state.firstName}
                                               onChange={(event) => this.setState({firstName: event.target.value})}
                                    />
                                </div>
                                <div className='input'>
                                    <TextField label='Фамилия' type='text' name='last_name' autoComplete="new-password"
                                               fullWidth
                                               value={this.state.lastName}
                                               onChange={(event) => this.setState({lastName: event.target.value})}
                                    />
                                </div>
                            </div>
                            <div className='inputs'>
                                <div className='input'>
                                    <TextField label='Email' name='email' type='email' autoComplete="new-password"
                                               fullWidth
                                               value={this.state.email}
                                               onChange={(event) => this.setState({email: event.target.value})}
                                    />
                                </div>
                                <div className='input'>
                                    <TextField label='Телефон' name='phone' type='tel' autoComplete="new-password"
                                               fullWidth
                                               value={this.state.phone}
                                               onChange={(event) => this.setState({phone: event.target.value})}
                                    />
                                </div>
                            </div>
                            <div className='inputs'>
                                <div className='input'>
                                    <TextField label='Пароль' name='password' type='password'
                                               autoComplete="new-password" fullWidth
                                               value={this.state.password}
                                               onChange={(event) => this.setState({password: event.target.value})}
                                    />
                                </div>
                            </div>
                            {
                                this.state.errorText ? <div className='error'>{this.state.errorText}</div> : null
                            }
                            <div className='buttons revert'>
                                <Link className='button secondary' to='/login/'>
                                    Назад
                                </Link>
                                <div className='button'
                                     onClick={() => this.register()}>
                                    Создать аккаунт
                                </div>
                            </div>
                        </div>
                        <div className='extra'>
                            <Link className='register link' to='/login/partners/'>У меня уже есть аккаунт</Link>
                            <Link className='forgot link' to='/forgot?type=partners'>Забыли пароль?</Link>
                        </div>
                        <div className='card sub-card'>
                            <div className='sub-card-content'>
                                <div className='title'>Хотите войти на портал?</div>
                                <div className='description'>
                                    Форма выше предназначена для тех, кто хочет войти в кабинет системы управления
                                    контентом — возможно, вы ищете не это
                                </div>
                            </div>
                            <div className='buttons'>
                                <Link className='button secondary' to='/login/portal/'>
                                    Да, я не бизнес-клиент
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state, ownProps) => ({
    user: state.system.user,
    partnerUser: state.system.partnerUser,
})

const mapDispatchToProps = (dispatch, ownProps) => {
    return bindActionCreators(
        {
            updatePartnerUser: updatePartnerUser,
            updateCollection: updateCollection,
            updateNavigationParam: updateNavigationParam,
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(withCookies(withRouterHOC(RegisterPartners)));